export const calculateTotalCharges = (selectedData, commission, type) => {
    // console.log('✌️type --->', type);
    // console.log('✌️selectedData, commission --->', selectedData);
    const additionalCharges = [
        "BBD", "CDL_CHARGES", "CF", "CPL_CHARGES", "CVD", "D_AC", "D_ADC", "D_AS",
        "D_CC", "D_DC", "D_DV", "D_KYC", "D_RP", "FOV_CHARGES", "FUEL", "HC", "NDD",
        "OTP", "PLAN_CHARGES", "QC", "SDL", "SECURE_SHIP_CHARGES", "TF", "TPC", "VCHC"
    ];

    const additionalChargesTotal = additionalCharges.reduce((sum, key) => {
        return sum + (selectedData?.chargesBreakup?.[key] || 0);
    }, 0);

    const codCommission = commission?.cod_order_percentage || 0;
    const freightCommission = commission?.freight_charge_percentage || 0;

    const COD = selectedData?.chargesBreakup?.COD || 0;
    const FRT = selectedData?.chargesBreakup?.FRT + additionalChargesTotal;


    // Apply 18% GST
    const codWithGST = COD * 1.18;
    const frtWithGST = FRT * 1.18;

    // Apply commission
    const codWithCommission = codWithGST * (1 + codCommission / 100);
    const frtWithCommission = frtWithGST * (1 + freightCommission / 100);

    // Calculate updated total charges
    const updatedTotalCharges = type === "EC" ? (codWithCommission + frtWithCommission) : (selectedData?.freight_charges * (1 + freightCommission / 100)) + (selectedData?.cod_charges * (1 + codCommission / 100));
    const freight_charges_order = type === "EC" ? frtWithCommission : (selectedData?.freight_charges * (1 + freightCommission / 100));
    // console.log('✌️updatedTotalCharges --->', updatedTotalCharges);
    return { total_charges: Number(updatedTotalCharges.toFixed(2)), rto_charges: Number(freight_charges_order?.toFixed(2)) };
};


export const generateDeliveryLink = (customerId) => {
    const baseUrl = window.location.origin;
    const encodedId = btoa(customerId); // Base64 encode
    return `${baseUrl}/submit-delivery/${encodedId}`;
};

